import { BaseModel } from "../../base.model";

export class ClientSignatureRequestModel extends BaseModel {
    clientId?: string;
    email?: string;
    requisitionId?: string; 
    myFileId?: string; 
    showPdfPreview?: boolean; 
    signUrl?: string;
}